import 'floating-vue/dist/style.css'
import '@/assets/css/floatingVue.css'

import FloatingVue from 'floating-vue'

class FloatingVueUtils {
  static init(Vue) {
    Vue.use(FloatingVue, {
      themes: {
        'tooltip-dark': {
          $extend: 'dropdown',
        },
        'tooltip-light': {
          $extend: 'tooltip-dark',
        },
        'tooltip-light-datepicker': {
          $extend: 'tooltip-light',
        },
        'tooltip-light-large': {
          $extend: 'tooltip-light',
        },
      },
    })
  }
}
export { FloatingVueUtils }
